@for (navigationUnit of navigationUnits(); track $index) {
    @if (hasUnitChildren(navigationUnit)) {
        <ng-container
            *ngTemplateOutlet="
                submenuButton;
                context: {
                    navigationUnit: navigationUnit,
                }
            "></ng-container>
    } @else {
        <ng-container
            *ngTemplateOutlet="
                redirectButton;
                context: {
                    navigationUnit: navigationUnit,
                }
            "></ng-container>
    }
}

<ng-template #redirectButton let-navigationUnit="navigationUnit">
    <div class="relative flex h-full">
        @if (navigationUnit.externalUrl) {
            <a
                matRipple
                class="shrl-text-h5-medium my-auto mr-3 flex text-nowrap rounded-md px-4 py-3 text-shrl-black hover:bg-slate-100"
                [href]="getExternalUrl(navigationUnit.externalUrl)"
                aria-label="Navigation">
                <ng-container
                    *ngTemplateOutlet="
                        navigationUnitLabel;
                        context: { navigationUnit }
                    " />
            </a>
        } @else {
            <button
                matRipple
                class="shrl-text-h5-medium my-auto mr-3 flex text-nowrap rounded-md px-4 py-3 text-shrl-black hover:bg-slate-100"
                [routerLink]="navigationUnit.fullPath"
                aria-label="Navigation">
                <ng-container
                    *ngTemplateOutlet="
                        navigationUnitLabel;
                        context: { navigationUnit }
                    " />
            </button>
        }
        <ng-container
            *ngTemplateOutlet="isActiveDiv; context: { navigationUnit }" />
    </div>
</ng-template>

<ng-template #submenuButton let-navigationUnit="navigationUnit">
    <div
        class="relative flex h-full"
        [matMenuTriggerFor]="menu"
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerData]="{ navigationUnit: navigationUnit }">
        <button
            matRipple
            class="shrl-text-h5-medium my-auto mr-3 flex text-nowrap rounded-md px-4 py-3 text-shrl-black hover:bg-slate-100"
            aria-label="Navigation">
            <ng-container
                *ngTemplateOutlet="
                    navigationUnitLabel;
                    context: { navigationUnit }
                " />

            <mat-icon
                class="my-auto ml-1"
                [@rotate]="{
                    value: menuTriggerToAnimationState(menuTrigger),
                    params: { duration: '0.2' },
                }">
                keyboard_arrow_down
            </mat-icon>
        </button>
        <ng-container
            *ngTemplateOutlet="isActiveDiv; context: { navigationUnit }" />
    </div>
</ng-template>

<ng-template #navigationUnitLabel let-navigationUnit="navigationUnit">
    @if (navigationUnit.iconName) {
        <shrl-icon
            class="my-auto mr-1.5"
            [iconName]="navigationUnit.iconName"></shrl-icon>
    }
    @if (navigationUnit.label) {
        <span>
            {{ navigationUnit.label | translate }}
        </span>
    }
</ng-template>

<ng-template #isActiveDiv let-navigationUnit="navigationUnit">
    <div
        [ngClass]="{
            'opacity-100': isActive(navigationUnit),
            'opacity-0': !isActive(navigationUnit),
            'h-full w-2': isHorizontal(),
            'h-2 w-full': !isHorizontal(),
        }"
        class="absolute bottom-0 right-0 h-2 w-full bg-shrl-cyan-500"></div>
</ng-template>

<mat-menu #menu="matMenu">
    <ng-template matMenuContent let-navigationUnit="navigationUnit">
        @for (childUnit of getChildren(navigationUnit); track $index) {
            @if (childUnit.externalUrl) {
                <a mat-menu-item [href]="getExternalUrl(childUnit.externalUrl)">
                    <div class="relative flex">
                        @if (childUnit.iconName) {
                            <shrl-icon
                                class="mr-2 h-6 w-6"
                                [iconName]="childUnit.iconName"></shrl-icon>
                        }
                        @if (childUnit.label) {
                            <span class="my-auto">
                                {{ childUnit.label | translate }}
                            </span>
                        }
                    </div>
                </a>
            } @else {
                <button mat-menu-item [routerLink]="childUnit.fullPath">
                    <div class="relative flex">
                        @if (childUnit.iconName) {
                            <shrl-icon
                                class="mr-2 h-6 w-6"
                                [iconName]="childUnit.iconName"></shrl-icon>
                        }
                        @if (childUnit.label) {
                            <span class="my-auto">
                                {{ childUnit.label | translate }}
                            </span>
                        }
                        @if (childUnit.matchFullPath) {
                            <div
                                class="absolute -left-3 -top-3 h-12 w-1 bg-shrl-cyan-500"></div>
                        }
                    </div>
                </button>
            }
        }
    </ng-template>
</mat-menu>
